import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { Box } from '@uhg-abyss/web/ui/Box';

const PictureCardContainer = styled('div', {
  display: 'flex',
  width: '100%',
  gap: '24px',
  'margin-bottom': '16px',
});

const StyledBox = styled(Box, {
  width: '313px',
  minWidth: '218px',
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'space-between',
  boxShadow:
    'rgba(0, 0, 0, 0.05) 0px 1px 3px, rgba(0, 0, 0, 0.05) 0px 10px 15px -5px, rgba(0, 0, 0, 0.04) 0px 7px 7px -5px',
  '&.abyss-box-root': {
    backgroundColor: '$white',
  },
});

const TopContainer = styled('div', {
  backgroundColor: '$white',
});

const IconContainer = styled('div', {
  'margin-bottom': '8px',
});

const TextContainer = styled('h4', {
  minHeight: '126px',
  lineHeight: '1.3',
  color: '$primary1',
  fontSize: '26px !important',
  fontWeight: '$bold',
  backgroundColor: '$white',
});

const TitleContainer = styled('div', {});

const DateContainer = styled('div', {});

const BottomContainer = styled('div', {
  backgroundColor: '$white',
});

const onClick = (title, date, url) => {
  event('YOUR_FEATURED_NEWS_WIDGET_CLICK', {
    interactionValue: 'View updates',
    interactionContext: `${title} ${date}`,
  });

  event('EXIT_LINK_NAVIGATE_YOUR_FEATURED_NEWS', {
    linkText: 'View updates',
    linkUrl: url || '',
  });
};

export const PictureCard = ({ pictureCardContent }) => {
  return (
    <PictureCardContainer>
      <For each="pictureCard" of={pictureCardContent}>
        <StyledBox key={`picture-card-id-${pictureCard.title}`}>
          <TopContainer>
            <IconContainer data-testid={pictureCardContent.dataTestidIcon}>
              {pictureCard.icon}
            </IconContainer>
            <TextContainer>
              <TitleContainer data-testid={pictureCardContent.dataTestidLabel}>
                {pictureCard.title}
              </TitleContainer>
              <DateContainer>{pictureCard.date}</DateContainer>
            </TextContainer>
          </TopContainer>
          <BottomContainer>
            <Button
              data-testid="your-featured-news-tile-view-updates-link"
              variant="outline"
              after={<IconSymbol icon="open_in_new" color="$primary1" />}
              style={{
                fontSize: '14px',
                borderWidth: '1px',
                outline: 'none',
                marginBottom: '8px',
              }}
              onClick={() =>
                onClick(pictureCard.title, pictureCard.date, pictureCard.url)
              }
              href={pictureCard.url}
            >
              View updates
            </Button>
          </BottomContainer>
        </StyledBox>
      </For>
    </PictureCardContainer>
  );
};

PictureCard.propTypes = {
  pictureCardContent: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
